import React from 'react';
import '../../App.css';

export default function AboutUs() {
  return <h1 className='about-us'>Abou US</h1>;
}
